module.exports = __webpack_public_path__ + "static/img/zaoxie-advert.aa402f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/videoDetail/zaoxie-advert.png
// module id = 4L3H
// module chunks = 17